module.exports = __webpack_public_path__ + "img/pagination-right-arrow.93d69a68.svg";